
// import './App.css';
import CareerType from './CareerType';
import ResidenceTiers from './ResidenceTiers';
import './dataviz.scss'
import RetirementYears from './RetirementYears';
import CareerTrend from './CareerTrend';
import GenderLongevityV2 from './GenderLongevityV2';
import Methodology from './Methodology';


function App() {

  return (
    <div className='App'>
    
    <div style={{ 
      height: '140vh' ,
      backgroundColor:'#F6F2EF', 
      position:'relative',
      }}>
        {/* 因金牌而改变一生 中国奥运冠军今何在 */}
      <img 
      src={`${process.env.PUBLIC_URL + '/images/chinese-olympic-golds_cover.jpg'}`} 
      alt={`因金牌而改变一生 中国奥运冠军今何在？`}
      style={{
        height:'98vh',
        width:'100%',
        objectFit:'cover',
        objectPosition: '7% 10%',
        position:'sticky',
        top:'0',
        zIndex:'0',
        transform: 'translate3d(0, 0, 0)'
      }}
      />
      <div style={{height:'2vh'}}></div>
      <div className='heading'>
        <div>
          <span>Data Report</span>
          {/* <h1>因金牌而改变一生<br/>&nbsp;中国奥运冠军今何在？</h1> */}
          <h1>Lives Changed by Gold: <br/>Where Are China's <br/>Olympic Champions Now?</h1>
          <p>08/12/2024</p>
          </div>
        </div>
      
      </div>


    <div className='content'>
      <div className='content__text intro'>
      <p>At the recently concluded Paris Olympics, the Chinese team won 40 gold medals, tying with the United States for first place in the world. In the 1984 Summer Olympics in Los Angeles, China achieved a historic breakthrough by winning its first-ever Olympic gold medal. In just 40 years, China has risen from having zero gold medals to becoming a gold medal powerhouse.</p>

      <p>From Xu Haifeng winning China’s first gold medal in shooting in 1984 to Li Wenwen securing the most recent gold in women's weightlifting in 2024, China has produced a total of 319 Olympic champions. There is no doubt that the efforts of these champions have reshaped China’s image in the Olympic Games. But has winning an Olympic gold medal truly changed their personal lives? Are champions in different sports given equal opportunities to capitalize on their fame? An athletic career is ultimately short-lived—how do these athletes transition into their second lives after retirement? And how have the expectations placed on the Olympics by the Chinese public influenced the career trajectories of these champions?</p>

      <p>歪脑 | WHYNOT has compiled publicly available information on the 319 Olympic champions born and raised in mainland China from 1984 to the present. By analyzing data such as their birthplaces, current residences, sports disciplines, and career paths, we can get a glimpse of the second life map of Chinese Olympic champions under the national sports system. WHYNOT shares our findings with you. Hover over the charts to explore detailed information.</p>

      </div>

      <div className='intro-image'>
          <img src={`${process.env.PUBLIC_URL + '/images/closing.jpeg'}`}
          alt={`2024年8月11日，巴黎奥运闭幕式，中国队走入体育场。`} />
          <div className='scroll__caption'>August 11, 2024, the Chinese team enters the stadium during the closing ceremoney of the Paris Olympics. (AP / Martin Meissner)</div>
      </div>

    </div>

    <CareerType />
    <CareerTrend />
    <ResidenceTiers/> 
    <GenderLongevityV2 /> 
    <RetirementYears />
    <Methodology /> 

    </div>
    );
}

export default App;
